import React, { useState, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import { MenuItem, Button, TextField, CircularProgress } from "@mui/material";
import * as Yup from "yup";
import { TrainingRequests } from "requests/TrainingRequests";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";

// Validation schema using Yup
const validationSchema = Yup.object({
  user: Yup.string().required("Please select a user"),
  reason: Yup.string().required("Please enter a reason"),
});

const ChangeTrainerForm = ({ onSubmit, batchIdReceived, closeModal }) => {
  const [users, setUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const batchId = queryParams.get("batch") ?? batchIdReceived;
  console.log("batchId", batchId, batchIdReceived);
  // Fetch users from API
  useEffect(() => {
    const fetchUsers = async () => {
      setLoadingUsers(true);
      try {
        const results = await TrainingRequests.getAllTrainers(); // Replace with your actual API call
        setUsers(results || []);
      } catch (error) {
        console.error("Error fetching users:", error);
        toast.error("Failed to load users.", { theme: "colored" });
      } finally {
        setLoadingUsers(false);
      }
    };
    fetchUsers();
  }, []);

  const handleSubmit = async (values) => {
    // console.log("Form Submitted:", values);
    try {
      if (onSubmit) {
        await onSubmit("values", values);
      } else {
        try {
          let assignStatus = await TrainingRequests.assignTrainerToExistingBatch(
            batchId,
            values.user,
            values.reason
          );
          if (assignStatus.status) {
            toast.success("Trainer Assigned", { theme: "colored" });
            if (closeModal) {
              closeModal();
            }
          } else {
            console.log("status", assignStatus, values);
            toast.error(`Failed to Assign Trainer`);
          }
        } catch (error) {
          toast.error(`Failed to Assign Trainer: ${error.message}`, {
            theme: "colored",
          });
        }
      }
    } catch (error) {
      console.error("Submit error:", error);
    }
  };

  return (
    <>
      <Formik
        initialValues={{ user: "", reason: "" }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ errors, touched, setFieldValue }) => (
          <Form>
            {/* User Dropdown */}
            <Field
              name="user"
              as={TextField}
              select
              label="Select Trainer"
              fullWidth
              margin="normal"
              error={touched.user && !!errors.user}
              helperText={touched.user && errors.user}
              disabled={loadingUsers}
              onChange={(e) => {
                setFieldValue("user", e.target.value);
              }}
            >
              {loadingUsers ? (
                <MenuItem value="" disabled>
                  <CircularProgress size={20} />
                </MenuItem>
              ) : (
                users.map((user) => (
                  <MenuItem key={user.employeeId} value={user.employeeId}>
                    {`${user.employeeId}-${user.employeeName}`}
                  </MenuItem>
                ))
              )}
            </Field>
            <Field
              name="reason"
              as={TextField}
              label="Reason"
              fullWidth
              margin="normal"
              error={touched.reason && !!errors.reason}
              helperText={touched.reason && errors.reason}
              multiline
              rows={4}
              onChange={(e) => {
                setFieldValue("reason", e.target.value);
              }}
            />

            {/* Submit Button */}
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              sx={{ mt: 2 }}
            >
              Submit
            </Button>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default ChangeTrainerForm;
